import { createSelector } from 'reselect'
import getCanRedeemTransferLoyaltyBenefit from './getCanRedeemTransferLoyaltyBenefit'
import getCanRedeemLoungePassLoyaltyBenefit from './getCanRedeemLoungePassLoyaltyBenefit'
import getCanRedeemStayUpgradeLoyaltyBenefit from './getCanRedeemStayUpgradeLoyaltyBenefit'
import getCanShowCheckoutLoyaltyEsimTile from './esim/getCanShowCheckoutLoyaltyEsimTile'
import getLoyaltyLoungePassItemViews from '../view/itemViews/getLoyaltyLoungePassItemViews'
import { getIsBookingOwnerForCheckoutOrder } from 'luxPlus/selectors/featureToggle'

const getCanRedeemCheckoutLoyaltyBenefits = createSelector(
  (state: App.State) => getIsBookingOwnerForCheckoutOrder(state),
  (state: App.State) => getCanRedeemTransferLoyaltyBenefit(state),
  (state: App.State) => getCanRedeemLoungePassLoyaltyBenefit(state),
  (state: App.State) => getCanRedeemStayUpgradeLoyaltyBenefit(state),
  (state: App.State) => getLoyaltyLoungePassItemViews(state),
  (state: App.State) => getCanShowCheckoutLoyaltyEsimTile(state),
  (
    isBookingOwner,
    canRedeemTransfers,
    canRedeemLoungePasses,
    canRedeemRoomUpgradeLoyaltyBenefit,
    loyaltyLoungePassItemViews,
    canShowCheckoutLoyaltyEsimTile,
  ): boolean => {
    if (!isBookingOwner) return false

    const hasPreselectedLoungePasses = loyaltyLoungePassItemViews.data.length > 0
    return canRedeemLoungePasses ||
      hasPreselectedLoungePasses ||
      canRedeemTransfers ||
      canRedeemRoomUpgradeLoyaltyBenefit ||
      canShowCheckoutLoyaltyEsimTile
  },
)

export default getCanRedeemCheckoutLoyaltyBenefits
